export type Sortable<TKey extends string> = {
  [key in TKey]: number | string | boolean;
};
export type SortableDate<TKey extends string> = { [key in TKey]: Date };

export type SortDirection = 'ASC' | 'DESC';

export const by =
  <TKey extends string>(sortKey: TKey, direction: SortDirection = 'ASC') =>
  (a: Sortable<TKey>, b: Sortable<TKey>) => {
    if (a[sortKey] < b[sortKey]) {
      return direction === 'ASC' ? -1 : 1;
    }
    if (a[sortKey] > b[sortKey]) {
      return direction === 'ASC' ? 1 : -1;
    }
    return 0;
  };

/**
 *
 * @param sortKey - key on object
 * @param ascending - true: oldest->newest
 * @returns
 */
export const byDate =
  <TKey extends string>(sortKey: TKey, direction: SortDirection = 'ASC') =>
  (a: SortableDate<TKey>, b: SortableDate<TKey>) => {
    if (direction === 'ASC') {
      return new Date(a[sortKey]).getTime() - new Date(b[sortKey]).getTime();
    } else {
      return new Date(b[sortKey]).getTime() - new Date(a[sortKey]).getTime();
    }
  };
